import { Config } from "@serenity-is/corelib";

Config.rootNamespaces.push('MRMX');
